import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../model/api-response';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(private http: HttpClient, private cookieService: CookieService) {
  }

  public getBackOffice<T>(url: string): Observable<ApiResponse<T>> {
    let userSession = this.cookieService.get(AuthService.userSessionKey)!;
    let header = new HttpHeaders({ 'SessionId': userSession });

    return this.http.get<ApiResponse<T>>(environment.backOfficeApiURL + url, { headers: header }).pipe(catchError(this.handleError))
  }

  public postBackOffice<T>(url: string, body: any, responseType?: any, header?: any): Observable<any> {
    if (!header) {
      header = new HttpHeaders();
    }

    let userSession = this.cookieService.get(AuthService.userSessionKey)!;
    header = header.set('SessionId', userSession);

    return this.http.post<any>(environment.backOfficeApiURL + url, body, { responseType: responseType, headers: header }).pipe(catchError(this.handleError))
  }

  public getCatalog<T>(url: string): Observable<ApiResponse<T>> {
    let userSession = this.cookieService.get(AuthService.userSessionKey)!;
    let header = new HttpHeaders({ 'SessionId': userSession });

    return this.http.get<ApiResponse<T>>(environment.catalogApiURL + url, { headers: header }).pipe(catchError(this.handleError))
  }

  public postCatalog<T>(url: string, body: any, responseType?: any, header?: any): Observable<any> {
    if (!header) {
      header = new HttpHeaders();
    }

    let userSession = this.cookieService.get(AuthService.userSessionKey)!;
    header = header.set('SessionId', userSession);

    return this.http.post<any>(environment.catalogApiURL + url, body, { responseType: responseType, headers: header }).pipe(catchError(this.handleError))
  }

  public postAuth(url: string, body: any, header?: any): Observable<HttpResponse<any>> {
    if (header) {
      return this.http.post<any>(environment.authAPIURL + url, body, { headers: header, observe: 'response' }).pipe(catchError(this.handleError))
    }
    else {
      return this.http.post<any>(environment.authAPIURL + url, body, { observe: 'response' }).pipe(catchError(this.handleError))
    }
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error );
  }
}
